module.exports = __webpack_public_path__ + "static/corona-4011b5d5a7a5afe724a93e70031d3196.svg";